import { render, staticRenderFns } from "./ResetPasswordIndex.vue?vue&type=template&id=50196f1a&scoped=true"
import script from "./ResetPasswordIndex.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50196f1a",
  null
  
)

export default component.exports